"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ATTAnimate = void 0;
var anime_service_1 = require("./services/animejs/anime-service");
var ATTAnimate = /** @class */ (function () {
    function ATTAnimate(injectables) {
        this.animationService = (injectables && injectables.animation) ?
            injectables.animation :
            new anime_service_1.default();
    }
    // register an animation
    ATTAnimate.prototype.addAnim = function (customProps) {
        var combinedProps = {};
        this.animationService
            .addAnim(customProps);
        return this;
    };
    // start playing the animationService
    ATTAnimate.prototype.play = function () {
        return this.animationService.play();
    };
    // pause the animationService
    ATTAnimate.prototype.pause = function () {
        this.animationService.pause();
        return this;
    };
    // set the initialstate of an element, such as hiding element before sliding into view
    ATTAnimate.prototype.setInitialState = function (initStates) {
        this.animationService.setInitialState(initStates);
        return this;
    };
    return ATTAnimate;
}());
exports.ATTAnimate = ATTAnimate;
//# sourceMappingURL=att-animate.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/containers/Animate/att-animate.js
// module id = 1098
// module chunks = 8